var els = $('.listing-availability');
if (els.length > 0) {
  require.ensure('../listings/availability_rules', function(require) {
    var AvailabilityRules = require('../listings/availability_rules');
    els.each(function() {
      return new AvailabilityRules(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/availability_rules.initializer.js